import React from "react";
import { Prompt } from "react-router-dom";
import EntityFields from "./EntityFields";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as staticDataActions } from "../redux/actions/staticDataActions";
import { actionCreators as selfServiceActions } from "../redux/actions/selfServiceActions";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ContactsIcon from "@material-ui/icons/Contacts";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import * as routeHelpers from "../authentication/routeHelpers";
import "./self-service.css";

class Entities extends React.Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.state = {
            snackbarOpen: false,
            snackbarContent: { message: "", alertType: "" },
            noticeDialogOpen: false,
            submitDialogOpen: false,
            submitFailed: false
        };
    }

    componentDidUpdate() {
        var errors = this.props.selfService.activeEntityFieldErrors;

        if (errors && Object.keys(errors).length > 0 && this.state.submitFailed) {
            this.scrollFieldIntoView(Object.keys(errors)[0]);
            this.state.submitFailed = false;
        }
    }


    componentDidMount() {
        const { actions } = this.props;
        if (!this.props.selfService.initialEntitiesRequest) {
            console.log('initialEntitiesRequest');
            actions.selfService.setEntitiesInitialRequestStatus(true);
            this.initialRequests(actions);
        }
    }

    componentWillUnmount() {
        this.props.actions.selfService.setEntitiesInitialRequestStatus(false);
    }


    async initialRequests(actions) {
        if (this.props.match.params.entityId && this.props.match.params.entityId != this.props.selfService.activeEntity?.EntityChangeRequestID) {
            await actions.selfService.checkIfIDVerificationIsEnabled();
            await actions.staticData.requestCountries();
            await actions.staticData.requestNationalities();
            await actions.staticData.requestDocumentSettings();
            await actions.selfService.requestEntities();
            await actions.selfService.requestEntityFields(this.props.match.params.entityId);
        }
        actions.selfService.setEntitiesInitialRequestStatus(false);
    }


    scrollFieldIntoView(fieldCode) {
        const yOffset = -80;
        const element = document.getElementById(fieldCode);

        if (element == null) {
            return;
        }

        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });

    }

    setNoticeDialogState(isOpen) {
        this.setState((state) => ({
            ...state,
            noticeDialogOpen: isOpen,
        }));
    }

    setSubmitDialogState(isOpen) {
        this.setState((state) => ({
            ...state,
            submitDialogOpen: isOpen,
            submitFailed: !isOpen
        }));
    }

    setSnackbarState(isOpen) {
        this.setState((state) => ({
            ...state,
            snackbarOpen: isOpen,
        }));
    }

    setSnackbarContent(message, alertType) {
        this.setState((state) => ({
            ...state,
            snackbarContent: { message: message, alertType: alertType },
        }));
    }

    showSnackBar(message, alertType) {
        this.setSnackbarContent(message, alertType)
        this.setSnackbarState(true)

    }

    handleSubmitFailed = (bool) => {
        this.state.submitFailed = bool;
    }


    handleSubmit = (fields) => {
        this.props.actions.selfService
            .submitEntityFields(this.props.selfService.activeEntity, fields)
            .then(() => {
                this.props.history.push(routeHelpers.buildRoute("")); //navigate to EntitiesDashboard component
            })
            .catch(() => {
                this.setSnackbarContent(
                    "Failed to submit entity data, please try again.",
                    "error"
                );
                this.setSnackbarState(true);
            });
    };

    handleSave = (fields, requestFields = true) => {
        return this.props.actions.selfService
            .saveEntityFields(this.props.selfService.activeEntity, fields)
            .then(() => {
                return requestFields
                    ? this.props.actions.selfService
                        .reloadEntityFields(this.props.selfService.activeEntity.EntityChangeRequestID)
                        .then((reloadedEntity) => {
                            if (this.props.selfService.newLoadedEntityFields.EntityFields.length ||
                                this.props.selfService.newLoadedEntityFields.CustomFields.length ||
                                this.props.selfService.newLoadedEntityFields.DocumentTypes.length ||
                                this.props.selfService.newLoadedEntityFields.RelatedCountryTypes.length ||
                                this.props.selfService.newLoadedEntityFields.IdentificationDocumentsRequireUpload) {
                                this.setNoticeDialogState(true);

                                return Promise.reject({ reason: "FIELDS_UPDATED" });
                            }

                            return Promise.resolve(reloadedEntity);
                        })
                    : Promise.resolve();;
            })
            .then((reloadedEntity) => {
                this.setSnackbarContent("Saved entity data.", "success");
                this.setSnackbarState(true);

                return Promise.resolve(reloadedEntity);
            })
            .catch((error) => {
                if (error && (!error.reason || error.reason !== "FIELDS_UPDATED")) {
                    this.setSnackbarContent(
                        "Failed to save entity data, please try again.",
                        "error"
                    );
                    this.setSnackbarState(true);
                }

                return Promise.reject(error);
            })
    };

    handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setSnackbarState(false);
    };

    handleNoticeDialogClose = () => {
        this.setNoticeDialogState(false);
    };

    handleSubmitDialogState = (isOpen) => {
        this.setSubmitDialogState(isOpen);
    };

    detectEntityFieldChange = () => {
        this.props.actions.selfService.setActiveEntityModified(true);
    };

    setEntityFieldErrors = (errors) => {
        if (!errors) return;

        this.props.actions.selfService.setActiveEntityFieldErrors(errors);
    };

    clearEntityFieldError = (fieldCode, section) => {
        this.props.actions.selfService.clearActiveEntityFieldError(fieldCode, section);
    };

    render() {
        // BREAKING PORTAL CHANGE REQUIRED HERE - conditionToShowEntityFields
        const conditionToShowEntityFields = this.props.selfService?.activeEntity?.EntityFields &&
            this.props.selfService.activeEntity.EntityFields.length;
        return (
            <>
                {this.props.selfService.isLoadingEntity ? (
                    <>
                        <div className="loader-message">
                            <CircularProgress />
                            <div style={{ marginTop: 10, fontStyle: "italic" }}>
                                Loading entity fields...
                            </div>
                        </div>
                    </>
                ) : this.props.selfService.error
                    ? (<>{this.props.selfService.error}</>)
                    : (
                        <>
                            {this.props.selfService.activeEntity &&
                                this.props.selfService.activeEntity.EntityChangeRequestID ? (
                                <>
                                    {this.props.staticData.isLoading ? (
                                        <>
                                            <LinearProgress color="secondary" variant="query" />
                                        </>) : (
                                        <>
                                            {conditionToShowEntityFields ? (
                                                <>
                                                    <EntityFields
                                                        showSnackBar={this.showSnackBar}
                                                        entity={this.props.selfService.activeEntity}
                                                        fieldErrors={
                                                            this.props.selfService.activeEntityFieldErrors
                                                        }
                                                        newLoadedFields={
                                                            this.props.selfService.newLoadedEntityFields
                                                        }
                                                        countries={this.props.staticData.countries}
                                                        nationalities={this.props.staticData.nationalities}
                                                        isWaitingRequest={
                                                            this.props.selfService.isWaitingRequest
                                                        }
                                                        submitFailed={this.handleSubmitFailed}
                                                        submitForm={this.handleSubmit}
                                                        saveForm={this.handleSave}
                                                        fieldChange={this.detectEntityFieldChange}
                                                        setFieldErrors={this.setEntityFieldErrors}
                                                        clearFieldError={this.clearEntityFieldError}
                                                        showSubmitDialog={this.handleSubmitDialogState}
                                                        isSubmitDialogOpen={this.state.submitDialogOpen}
                                                        idVerificationIsEnabled={this.props.selfService.idVerificationIsEnabled}
                                                        idVerificationSkipped={this.props.selfService.idVerificationSkipped}
                                                        history={this.props.history}
                                                        location={this.props.location}
                                                    />
                                                </>
                                            ) : (
                                                <p>No fields to show for this entity.</p>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}

                            <div style={{ marginTop: 20 }}>
                                {this.props.selfService.isWaitingRequest ? (
                                    <div>
                                        <LinearProgress color="secondary" />
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                        </>
                    )}
                <Snackbar
                    open={this.state.snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleSnackbarClose}
                >
                    <Alert
                        onClose={this.handleSnackbarClose}
                        severity={this.state.snackbarContent.alertType}
                    >
                        {this.state.snackbarContent.message}
                    </Alert>
                </Snackbar>

                <Dialog
                    open={this.state.noticeDialogOpen}
                    onClose={this.handleNoticeDialogClose}
                >
                    <DialogTitle>
                        Notice
                        <IconButton
                            style={{ float: "right" }}
                            onClick={this.handleNoticeDialogClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The form has been updated, please provide information for the
                            following added fields then re-submit the form:
                        </DialogContentText>
                        <Typography component="div" variant="body2" color="secondary">
                            {this.props.selfService.newLoadedEntityFields.EntityFields && this.props.selfService.newLoadedEntityFields.EntityFields.map((field) => (
                                <div key={field.FieldCode}>Basic Details - {field.FieldName}</div>
                            ))}
                            {this.props.selfService.newLoadedEntityFields.CustomFields && this.props.selfService.newLoadedEntityFields.CustomFields.map((field) => (
                                <div key={field.FieldCode}>Additional Information - {field.FieldName}</div>
                            ))}
                            {this.props.selfService.newLoadedEntityFields.RelatedCountryTypes && this.props.selfService.newLoadedEntityFields.RelatedCountryTypes.map((field) => (
                                <div key={field.FieldCode}>Associated Countries - {field.FieldName}</div>
                            ))}
                            {this.props.selfService.newLoadedEntityFields.DocumentTypes && this.props.selfService.newLoadedEntityFields.DocumentTypes.map((field) => (
                                <div key={field.FieldCode}>Documentation - {field.FieldName}</div>
                            ))}
                            {this.props.selfService.newLoadedEntityFields && this.props.selfService.newLoadedEntityFields.IdentificationDocumentsRequireUpload ? <div>Identification Documents - Documents require upload</div> : <div></div>}
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ margin: 10 }}></DialogActions>
                </Dialog>
                <Prompt
                    when={this.props.selfService.isActiveEntityModified}
                    message="Your changes have not been saved.  Are you sure you want to navigate away from this page?"
                />
            </>
        );
    }
}

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function mapStateToProps(state) {
    return {
        selfService: state.selfService,
        staticData: state.staticData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            staticData: bindActionCreators(staticDataActions, dispatch),
            selfService: bindActionCreators(selfServiceActions, dispatch),
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Entities);
